import onKeyboardMarkAsJunkNotJunk from '../actions/actionCreators/onKeyboardMarkAsJunkNotJunk';
import { orchestrator } from 'satcheljs';
import markRowsJunkNotJunkFromTable from 'owa-mail-triage-action/lib/actions/markAsJunk/markRowsJunkNotJunkFromTable';
import markItemsJunkNotJunkBasedOnNodeIds from 'owa-mail-triage-action/lib/actions/actionCreators/markItemsJunkNotJunkBasedOnNodeIds';

// Orchestrator for keyboard mark as junk/notjunk on both item parts and rows
export default orchestrator(onKeyboardMarkAsJunkNotJunk, actionMessage => {
    const { tableView, selectedNodeIds, selectedRowKeys } = actionMessage;

    // Is item part operation
    if (selectedNodeIds.length > 0) {
        markItemsJunkNotJunkBasedOnNodeIds(
            selectedNodeIds,
            tableView.id,
            true /* isJunkValueToSet */,
            'Keyboard' /* actionSource */
        );
        // Is row operation
    } else {
        if (selectedRowKeys.length === 0) {
            return;
        }

        markRowsJunkNotJunkFromTable(
            selectedRowKeys,
            tableView,
            true /* isJunkValueToSet */,
            'Keyboard' /* actionSource */
        );
    }
});
